import { Menu as ReactMenu } from '@szhsin/react-menu';
import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/slide.css';
import React, { forwardRef } from 'react';
import { MenuItemWrapper } from './Components/MenuItemWrapper';
import { MenuProps } from './types';

export const Menu = forwardRef<HTMLDivElement, MenuProps>(
    (
        {
            items,
            onSelect,
            MenuButtonComponent,
            ItemComponent,
            TitleComponent,
            menuClassName,
            submenuProps,
            menuItemProps,
            ...menuProps
        },
        ref
    ) => {
        return (
            <ReactMenu
                ref={ref}
                menuButton={MenuButtonComponent}
                menuClassName={menuClassName}
                {...menuProps}
            >
                {TitleComponent && <TitleComponent />}
                {items.map(item => (
                    <MenuItemWrapper
                        key={`root-${item.value}`}
                        item={item}
                        onSelect={onSelect}
                        ItemComponent={ItemComponent}
                        menuItemProps={menuItemProps}
                        {...submenuProps}
                    />
                ))}
            </ReactMenu>
        );
    }
);
